<template>
  <div class="container p-2" v-if="tes_id != '' && DateStep.Step1 != ''">
    <div class="container p-2">
      <div class="alert alert-primary text-center" role="alert">
        <div class="progress">
          <div
            class="progress-bar"
            role="progressbar"
            style="width: 30%"
            aria-valuenow="25"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            30%
          </div>
        </div>
        <h3 class="p-3">ขั้นตอนที่ 2</h3>
        ประวัติส่วนตัว
      </div>
      <div class="alert alert-secondary" role="alert">
        <div class="col-12 my-4 text-center">
          <h1><b>ข้อมูลบุคคล</b></h1>
          <h2 class="text-danger">
            รับสมัครปีการศึกษา {{ getDataFrom3.select_year }}
          </h2>
          <h6 class="text-danger">
            กรุณากรอกข้อมูลให้ครบทั้งหมด การสมัครเรียนแบ่งออกเป็น 5 ส่วน <br />
            <b>
              หากกรอกข้อมูลไม่ครบส่วนใดส่วนหนึ่ง
              จะถือว่าการสมัครเรียนหรือจองที่เรียนไม่สมบูรณ์</b
            ><br />
            หากไม่มีข้อมูลให้ใส่เครื่องหมาย<br />
            พบปัญหาเกี่ยวกับการกรอกข้อมูลติดต่อ 053-213061 ต่อ 112
          </h6>
        </div>
        <form @submit.prevent="SetStepStatus(4)">
          <div class="form-group">
            <div class="row">
              <div class="col-lg-12">
                <fieldset class="rounded-4 border mb-5 border-primary p-3">
                  <legend class="float-none w-auto px-3 fw-bold">
                    <h3 class="text-primary"><b> ประวัติส่วนตัว</b></h3>
                  </legend>
                  <div class="my-5 text-center"></div>
                  <div class="row form-group d-flex justify-content-center">
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          วัน/เดือน/ปีเกิด <p style="color: red">*</p>
                        </div>
                      </h6>
                      <input
                        type="date"
                        class="form-control"
                        v-model="stu_birthData"
                        @input="formatDate"
                        :max="getMaxDate()"
                        :min="getMinDate()"
                        required
                      />
                      <!-- :class="{ 'error-border': yearError }" -->
                      <!-- <div v-if="yearError" class="error-message">
                        <pre class="mt-1 mb-0">
กรุณาระบุเป็น ค.ศ. เกิด(คริสศักราช)</pre
                        >
                      </div> -->
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          อายุ
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <input
                        type="number"
                        class="form-control"
                        placeholder="อายุ"
                        v-model="getDataFrom3.stu_age"
                        inputmode="numeric"
                        required
                      />
                      <!-- @input="maxAge" -->
                      <!-- {{ stubirthData }} -->
                    </div>
                  </div>
                  <div class="row form-group d-flex justify-content-center">
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          สัญชาติ
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="getDataFrom3.stu_nation"
                        required
                      >
                        <option
                          v-for="item in getDataNation"
                          :key="item.nt_id"
                          :value="item.nt_id"
                        >
                          {{ item.nt_name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          เชื้อชาติ
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="getDataFrom3.stu_lineage"
                        required
                      >
                        <option
                          value=""
                          selected
                          disabled
                          style="background-color: lightgray"
                        ></option>
                        <option
                          v-for="item in getDataLineage"
                          :key="item.lg_id"
                          :value="item.lg_id"
                        >
                          {{ item.lg_name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row form-group d-flex justify-content-center">
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          ศาสนา
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="getDataFrom3.stu_relagion"
                        required
                      >
                        <option
                          value=""
                          selected
                          disabled
                          style="background-color: lightgray"
                        ></option>
                        <option
                          v-for="item in getDataReligion"
                          :key="item.rel_id"
                          :value="item.rel_id"
                        >
                          {{ item.rel_name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          กรุ๊ปเลือด
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="getDataFrom3.stu_blood"
                        required
                      >
                        <option
                          value=""
                          selected
                          disabled
                          style="background-color: lightgray"
                        ></option>
                        <option
                          v-for="item in getDataBlood"
                          :key="item.bl_id"
                          :value="item.bl_id"
                        >
                          {{ item.bl_name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row form-group d-flex justify-content-center">
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          เพศ
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="getDataFrom3.stu_sex"
                        required
                      >
                        <option value="M">ชาย</option>
                        <option value="F">หญิง</option>
                      </select>
                    </div>
                    <div class="col-lg-5 my-3"></div>
                  </div>
                  <div class="row form-group d-flex justify-content-center">
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          มีพี่
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <input
                        type="number"
                        class="form-control"
                        placeholder="มีพี่"
                        v-model="getDataFrom3.stu_brother"
                        inputmode="numeric"
                        min="0"
                        required
                      />
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          มีน้อง
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <input
                        type="number"
                        class="form-control"
                        placeholder="มีน้อง"
                        v-model="getDataFrom3.stu_sister"
                        inputmode="numeric"
                        min="0"
                        required
                      />
                    </div>
                  </div>
                  <div class="row form-group d-flex justify-content-center">
                    <div class="col-lg-4 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          ผู้สมัครเป็นบุตรคนที่
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <input
                        type="number"
                        class="form-control"
                        placeholder="เป็นบุตรคนที่"
                        v-model="getDataFrom3.stu_order"
                        inputmode="numeric"
                        min="0"
                        required
                      />
                    </div>
                    <div class="col-lg-3 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          น้ำหนัก
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <input
                        type="number"
                        class="form-control"
                        placeholder="น้ำหนัก"
                        inputmode="numeric"
                        min="0"
                        v-model="getDataFrom3.stu_weight"
                        required
                      />
                    </div>
                    <div class="col-lg-3 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          ส่วนสูง
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <input
                        type="number"
                        class="form-control"
                        placeholder="ส่วนสูง"
                        inputmode="numeric"
                        min="0"
                        v-model="getDataFrom3.stu_height"
                        required
                      />
                    </div>
                  </div>
                  <div class="row form-group d-flex justify-content-center">
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          โรคประจำตัว (หากไม่มีให้ใส่เครื่องหมาย - )
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="โรคประจำตัว"
                        maxlength="50"
                        v-model="getDataFrom3.stu_health"
                        required
                      />
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          สถานะภาพครอบครัว
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="getDataFrom3.stu_parent_status"
                        required
                      >
                        <option
                          v-for="item in getDataParentStatus"
                          :key="item.pa_id.trim()"
                          :value="item.pa_id.trim()"
                        >
                          {{ item.pa_name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row form-group d-flex justify-content-center">
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">E-mail ผู้สมัคร</div>
                      </h6>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="E-mail"
                        maxlength="150"
                        v-model="getDataFrom3.stu_email"
                        @input="validateEmail"
                        :class="{ 'error-border': emailError }"
                      />
                      <div v-if="emailError" class="error-message">
                        <pre>กรุณากรอกอีเมลให้ถูกต้อง</pre>
                      </div>
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left" style="font-weight: bold">
                        <div class="d-flex">
                          ความสามารถพิเศษ (หากไม่มีให้ใส่เครื่องหมาย - )
                          <p style="color: red">*</p>
                        </div>
                      </h6>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="ความสามารถพิเศษ"
                        maxlength="1000"
                        v-model="getDataFrom3.stu_spacial"
                        required
                      />
                    </div>
                  </div>
                  <div
                    class="row form-group d-flex justify-content-center my-5"
                  >
                    <div class="col-lg-3 my-3">
                      <fieldset class="rounded-4 border border-primary">
                        <h6 class="text-left" style="font-weight: bold">
                          <div class="d-flex justify-content-center mt-3">
                            ถนัดเขียน
                            <p style="color: red">*</p>
                          </div>
                        </h6>
                        <div class="d-flex justify-content-center mb-3">
                          <div class="col-5 mx-2">
                            <input
                              class="btn-check"
                              type="radio"
                              name="hand_write"
                              id="hand_writeR"
                              value="R"
                              v-model="getDataFrom3.stu_hand_write"
                              :required="getDataFrom3.stu_hand_write"
                            />
                            <label
                              class="btn btn-outline-primary btn-light w-100"
                              for="hand_writeR"
                            >
                              ขวา
                            </label>
                          </div>
                          <div class="col-5 mx-2">
                            <input
                              class="btn-check"
                              type="radio"
                              name="hand_write"
                              id="hand_writeL"
                              value="L"
                              v-model="getDataFrom3.stu_hand_write"
                            />
                            <label
                              class="btn btn-outline-primary btn-light w-100"
                              for="hand_writeL"
                            >
                              ซ้าย
                            </label>
                          </div>
                        </div>
                      </fieldset>
                    </div>

                    <div class="col-lg-5 my-3">
                      <fieldset class="rounded-4 border border-danger">
                        <div
                          class="row d-flex justify-content-center mt-3 mx-2"
                        >
                          <h6 class="text-left" style="font-weight: bold">
                            <div class="d-flex justify-content-center">
                              รอยสัก
                              <p style="color: red">*</p>
                            </div>
                          </h6>
                          <div class="col-md-4 mb-3 col-8">
                            <input
                              class="btn-check"
                              type="radio"
                              name="tattoo"
                              id="tattooN"
                              value="0"
                              v-model="getDataFrom3.stu_tattoo"
                              :required="getDataFrom3.stu_tattoo"
                            />
                            <label
                              class="btn btn-outline-danger btn-light w-100"
                              for="tattooN"
                            >
                              ไม่มี
                            </label>
                          </div>
                          <div class="col-md-4 mb-3 col-8">
                            <input
                              class="btn-check"
                              type="radio"
                              name="tattoo"
                              id="tattooYI"
                              value="1"
                              v-model="getDataFrom3.stu_tattoo"
                            />
                            <label
                              class="btn btn-outline-danger btn-light w-100"
                              for="tattooYI"
                            >
                              มีในร่มผ้า
                            </label>
                          </div>
                          <div class="col-md-4 col-8">
                            <input
                              class="btn-check"
                              type="radio"
                              name="tattoo"
                              id="tattooYO"
                              value="2"
                              v-model="getDataFrom3.stu_tattoo"
                            />
                            <label
                              class="btn btn-outline-danger btn-light w-100"
                              for="tattooYO"
                            >
                              มีนอกร่มผ้า
                            </label>
                          </div>
                        </div>
                      </fieldset>
                    </div>
                    <div class="col-lg-3 my-3">
                      <fieldset class="rounded-4 border border-primary">
                        <h6 class="text-left" style="font-weight: bold">
                          <div class="d-flex justify-content-center mt-3">
                            การเจาะหู
                            <p style="color: red">*</p>
                          </div>
                        </h6>
                        <div class="d-flex justify-content-center">
                          <div class="col-5 mx-2">
                            <input
                              class="btn-check"
                              type="radio"
                              name="piercing_ear"
                              id="piercing_earY"
                              value="1"
                              v-model="getDataFrom3.stu_piercing_ear"
                              :required="getDataFrom3.stu_piercing_ear"
                            />
                            <label
                              class="btn btn-outline-primary btn-light w-100"
                              for="piercing_earY"
                            >
                              มี
                            </label>
                          </div>
                          <div class="col-5 mx-2 mb-3">
                            <input
                              class="btn-check"
                              type="radio"
                              name="piercing_ear"
                              id="piercing_earN"
                              value="0"
                              v-model="getDataFrom3.stu_piercing_ear"
                            />
                            <label
                              class="btn btn-outline-primary btn-light w-100"
                              for="piercing_earN"
                            >
                              ไม่มี
                            </label>
                          </div>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                  <div class="row form-group d-flex mx-5">
                    <div class="col-lg-12 my-3">
                      <fieldset class="rounded-4 border border-primary">
                        <h6 style="font-weight: bold">
                          <div class="d-flex justify-content-center mb-3 mt-4">
                            ได้รับข่าวสารจาก
                            <p style="color: red">*</p>
                          </div>
                        </h6>
                        <div
                          class="row form-group d-flex justify-content-center mx-1"
                        >
                          <div class="col-lg-2 pb-3">
                            <input
                              class="form-check-input me-2"
                              type="checkbox"
                              value="ผู้ปกครอง"
                              id="check_1"
                              v-model="stu_receipt_news_otherData"
                            />
                            <label for="check_1" class="checkmark user-select-none">(1) ผู้ปกครอง</label>
                          </div>
                          <div class="col-lg-2 pb-3">
                            <input
                              class="form-check-input me-2"
                              type="checkbox"
                              value="เพื่อน"
                              id="check_2"
                              v-model="stu_receipt_news_otherData"
                            />
                            <label for="check_2" class="checkmark user-select-none">(2) เพื่อน</label>
                          </div>
                          <div class="col-lg-3 pb-3">
                            <input
                              class="form-check-input me-2"
                              type="checkbox"
                              value="ครูแนะแนวของ รร.ตนเอง"
                              id="check_3"
                              v-model="stu_receipt_news_otherData"
                            />
                            <label for="check_3" class="checkmark user-select-none">(3) ครูแนะแนวของ รร.ตนเอง</label>
                          </div>
                          <div class="col-lg-4 pb-3">
                            <input
                              class="form-check-input me-2"
                              type="checkbox"
                              value="ครูแนะแนวของ วิทยาลัยโปลิฯ"
                              id="check_4"
                              v-model="stu_receipt_news_otherData"
                            />
                            <label for="check_4" class="checkmark user-select-none">(4) ครูแนะแนวของ วิทยาลัยโปลิฯ</label>
                          </div>
                        </div>
                        <div
                          class="row form-group d-flex justify-content-center mx-1"
                        >
                          <div class="col-lg-2 pb-3">
                            <input
                              class="form-check-input me-2"
                              type="checkbox"
                              value="สื่อสิ่งพิมพ์"
                              id="check_5"
                              v-model="stu_receipt_news_otherData"
                            />
                            <label for="check_5" class="checkmark user-select-none">(5) สื่อสิ่งพิมพ์</label>
                          </div>
                          <div class="col-lg-2 pb-3">
                            <input
                              class="form-check-input me-2"
                              type="checkbox"
                              value="จาก นศ. โปลิ"
                              id="check_6"
                              v-model="stu_receipt_news_otherData"
                            />
                            <label for="check_6" class="checkmark user-select-none">(6) จาก นศ. โปลิ</label>
                          </div>
                          <div class="col-lg-3 pb-3">
                            <input
                              class="form-check-input me-2"
                              type="checkbox"
                              value="เคยมาดูงาน"
                              id="check_7"
                              v-model="stu_receipt_news_otherData"
                            />
                            <label for="check_7" class="checkmark user-select-none">(7) ทราบจากกำนันผู้ใหญ่บ้าน</label>
                          </div>
                          <div class="col-lg-4 pb-3">
                            <input
                              class="form-check-input me-2"
                              type="checkbox"
                              value="Facebook ,Line ,Website ,Tiktok"
                              id="check_8"
                              v-model="stu_receipt_news_otherData"
                            />
                            <label for="check_8" class="checkmark user-select-none">(8) Facebook ,Line ,Website ,Tiktok</label>
                          </div>
                        </div>
                        <div
                          class="row form-group d-flex justify-content-center mx-1"
                        >
                          <div class="col-lg-2 pb-3">
                            <input
                              class="form-check-input me-2"
                              type="checkbox"
                              value="ทราบจากกำนันผู้ใหญ่บ้าน"
                              id="check_9"
                              v-model="stu_receipt_news_otherData"
                            />
                            <label for="check_9" class="checkmark user-select-none">(9) เคยมาดูงาน</label>
                          </div>
                          <div class="col-lg-9 pb-3">
                            <input
                              class="form-check-input me-2"
                              type="checkbox"
                              value="อื่นๆ"
                              id="check_10"
                              v-model="stu_receipt_news_otherData"
                            />
                            <label for="check_10" class="checkmark user-select-none">(10) อื่นๆ</label>
                          </div>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                </fieldset>
              </div>
              <div class="col-lg-12">
                <!-- ข้อมูลบิดา -->
                <fieldset class="rounded-4 border border-primary p-3 mb-5">
                  <legend class="float-none w-auto px-3 fw-bold">
                    <h3 class="text-primary"><b> ข้อมูลบิดามารดา</b></h3>
                  </legend>
                  <div class="row form-group">
                    <div class="my-4 text-md-center">
                      <h4><b>ข้อมูลบิดา</b></h4>
                    </div>
                  </div>
                  <div class="row form-group d-flex justify-content-center">
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">วัน/เดือน/ปีเกิด บิดา</div>
                      </h6>
                      <input
                        type="date"
                        class="form-control"
                        placeholder="วัน/เดือน/ปีเกิด บิดา"
                        v-model="stu_fat_birthData"
                        @input="formatDatefat"
                        :max="getMaxDate()"
                        :min="getMinDateDadMom()"
                      />
                      <!-- :class="{ 'error-border': yearErrorDad }" -->
                      <!-- <div v-if="yearErrorDad" class="error-message">
                        <pre class="mt-1 mb-0">
กรุณาระบุเป็น ค.ศ. เกิด(คริสศักราช)</pre
                        >
                      </div> -->
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">คำนำหน้าชื่อบิดา</div>
                      </h6>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="getDataFrom3.father_prename"
                      >
                        <option
                          value=""
                          selected
                          disabled
                          style="background-color: lightgray"
                        ></option>
                        <option
                          v-for="item in getDataPrename"
                          :key="item.pre_id"
                          :value="item.pre_id"
                        >
                          {{ item.pre_prename }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row form-group d-flex justify-content-center">
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">ชื่อบิดา</div>
                      </h6>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="ชื่อบิดา"
                        maxlength="30"
                        v-model="getDataFrom3.stu_father_fname"
                      />
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">นามสกุลบิดา</div>
                      </h6>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="นามสกุลบิดา"
                        maxlength="30"
                        v-model="getDataFrom3.stu_father_lname"
                      />
                    </div>
                  </div>
                  <div class="row form-group d-flex justify-content-center">
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">อาชีพบิดา</div>
                      </h6>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="getDataFrom3.stu_fat_occ"
                      >
                        <option
                          value=""
                          selected
                          disabled
                          style="background-color: lightgray"
                        ></option>
                        <option
                          v-for="item in getDataOccupationNew"
                          :key="item.oc_id"
                          :value="item.oc_id"
                        >
                          {{ item.oc_name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">
                          รายได้บิดาต่อเดือน (หากไม่ทราบให้ระบุเป็น 0)
                        </div>
                      </h6>
                      <input
                        type="number"
                        class="form-control"
                        placeholder="ระบุเป็นตัวเลข"
                        v-model="getDataFrom3.stu_fat_mon"
                        min="0"
                        @input="maxSalaryFat"
                      />
                    </div>
                  </div>
                  <div class="row form-group d-flex justify-content-center">
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">สภาพบิดา</div>
                      </h6>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="getDataFrom3.stu_father_state"
                      >
                        <option
                          value=""
                          selected
                          disabled
                          style="background-color: lightgray"
                        ></option>
                        <option
                          v-for="item in getDataLivingstate"
                          :key="item.lvt_id"
                          :value="item.lvt_id"
                        >
                          {{ item.lvt_name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">ความพิการบิดา</div>
                      </h6>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="getDataFrom3.stu_father_defective"
                      >
                        <option
                          value=""
                          selected
                          disabled
                          style="background-color: lightgray"
                        ></option>
                        <option
                          v-for="item in getDataDefective"
                          :key="item.de_id.trim()"
                          :value="item.de_id.trim()"
                        >
                          {{ item.de_name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <!-- ข้อมูลมารดา -->
                  <div class="row form-group">
                    <div class="my-4 text-md-center">
                      <h4><b>ข้อมูลมารดา</b></h4>
                    </div>
                  </div>
                  <div class="row form-group d-flex justify-content-center">
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">วัน/เดือน/ปีเกิด มารดา</div>
                      </h6>
                      <input
                        type="date"
                        class="form-control"
                        placeholder="วัน/เดือน/ปีเกิด มารดา"
                        v-model="stu_mom_birthData"
                        @input="formatDatemom"
                        :max="getMaxDate()"
                        :min="getMinDateDadMom()"
                      />
                      <!-- :class="{ 'error-border': yearErrorMom }" -->
                      <!-- <div v-if="yearErrorMom" class="error-message">
                        <pre class="mt-1 mb-0">
กรุณาระบุเป็น ค.ศ. เกิด(คริสศักราช)</pre
                        >
                      </div> -->
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">คำนำหน้าชื่อมารดา</div>
                      </h6>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="getDataFrom3.mother_prename"
                      >
                        <option
                          value=""
                          selected
                          disabled
                          style="background-color: lightgray"
                        ></option>
                        <option
                          v-for="item in getDataPrename"
                          :key="item.pre_id"
                          :value="item.pre_id"
                        >
                          {{ item.pre_prename }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row form-group d-flex justify-content-center">
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">ชื่อมารดา</div>
                      </h6>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="ชื่อมารดา"
                        maxlength="30"
                        v-model="getDataFrom3.stu_mother_fname"
                      />
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">นามสกุลมารดา</div>
                      </h6>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="นามสกุลมารดา"
                        maxlength="30"
                        v-model="getDataFrom3.stu_mother_lname"
                      />
                    </div>
                  </div>
                  <div class="row form-group d-flex justify-content-center">
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">อาชีพมารดา</div>
                      </h6>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="getDataFrom3.stu_mom_occ"
                      >
                        <option
                          value=""
                          selected
                          disabled
                          style="background-color: lightgray"
                        ></option>
                        <option
                          v-for="item in getDataOccupationNew"
                          :key="item.oc_id"
                          :value="item.oc_id"
                        >
                          {{ item.oc_name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">
                          รายได้มารดาต่อเดือน (หากไม่ทราบให้ระบุเป็น 0)
                        </div>
                      </h6>
                      <input
                        type="number"
                        class="form-control"
                        placeholder="ระบุเป็นตัวเลข"
                        v-model="getDataFrom3.stu_mom_mon1"
                        min="0"
                        @input="maxSalaryMom"
                      />
                    </div>
                  </div>
                  <div class="row form-group d-flex justify-content-center">
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">สภาพมารดา</div>
                      </h6>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="getDataFrom3.stu_mother_state"
                      >
                        <option
                          value=""
                          selected
                          disabled
                          style="background-color: lightgray"
                        ></option>
                        <option
                          v-for="item in getDataLivingstate"
                          :key="item.lvt_id"
                          :value="item.lvt_id"
                        >
                          {{ item.lvt_name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-5 my-3">
                      <h6 class="text-left mb-4" style="font-weight: bold">
                        <div class="d-flex">ความพิการมารดา</div>
                      </h6>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="getDataFrom3.stu_mother_defective"
                      >
                        <option
                          value=""
                          selected
                          disabled
                          style="background-color: lightgray"
                        ></option>
                        <option
                          v-for="item in getDataDefective"
                          :key="item.de_id.trim()"
                          :value="item.de_id.trim()"
                        >
                          {{ item.de_name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row mt-5">
                    <div class="form-group alert alert-primary">
                      <div class="d-flex mb-4 justify-content-center">
                        <h4>
                          <b> ประเภทการขอกู้ยืมเรียน</b>
                        </h4>
                      </div>
                      <div class="row form-group d-flex justify-content-center">
                        <fieldset
                          class="row d-flex justify-content-center rounded-4 border border-primary p-3 mb-3 col-7"
                        >
                          <legend class="float-none w-auto px-3">
                            <h5 class="">ประสงค์กู้</h5>
                          </legend>
                          <div class="col-md-4 col-8 mb-3">
                            <input
                              type="radio"
                              class="btn-check"
                              name="options-loanstat"
                              id="btn-check-loanstat1"
                              autocomplete="off"
                              value="0"
                              v-model="getDataFrom3.student_loan_stat"
                              @click="student_loanstat1()"
                            />
                            <label
                              class="btn btn-outline-primary btn-light w-100"
                              for="btn-check-loanstat1"
                              >ไม่ประสงค์กู้</label
                            >
                          </div>
                          <div class="col-md-4 col-8 mb-3">
                            <input
                              type="radio"
                              class="btn-check"
                              name="options-loanstat"
                              id="btn-check-loanstat2"
                              autocomplete="off"
                              value="1"
                              v-model="getDataFrom3.student_loan_stat"
                              @click="student_loanstat2()"
                            />
                            <label
                              class="btn btn-outline-primary btn-light w-100"
                              for="btn-check-loanstat2"
                              >ประสงค์กู้ กยศ.</label
                            >
                          </div>
                          <div class="col-md-4 col-8 mb-3">
                            <input
                              type="radio"
                              class="btn-check"
                              name="options-loanstat"
                              id="btn-check-loanstat3"
                              autocomplete="off"
                              value="2"
                              v-model="getDataFrom3.student_loan_stat"
                              @click="student_loanstat2()"
                            />
                            <label
                              class="btn btn-outline-primary btn-light w-100"
                              for="btn-check-loanstat3"
                              >ประสงค์กู้ กรอ.</label
                            >
                          </div>
                        </fieldset>
                      </div>
                      <div
                        class="row form-group d-flex justify-content-center"
                        v-if="status_lone == true"
                      >
                        <fieldset
                          class="row d-flex justify-content-center rounded-4 border border-primary p-3 col-7"
                        >
                          <legend class="float-none w-auto px-3">
                            <h5 class="">ประเภทการกู้</h5>
                          </legend>
                          <div class="col-md-4 col-8 mb-3">
                            <input
                              type="radio"
                              class="btn-check"
                              name="options-loanconti"
                              id="btn-check-loanconti1"
                              autocomplete="off"
                              value="1"
                              v-model="getDataFrom3.student_loan_continus"
                            />
                            <label
                              class="btn btn-outline-danger btn-light w-100"
                              for="btn-check-loanconti1"
                              >กู้ต่อเนื่องจากสถาบันเดิม</label
                            >
                          </div>
                          <div class="col-md-4 col-8">
                            <input
                              type="radio"
                              class="btn-check"
                              name="options-loanconti"
                              id="btn-check-loanconti2"
                              autocomplete="off"
                              value="2"
                              v-model="getDataFrom3.student_loan_continus"
                            />
                            <label
                              class="btn btn-outline-danger btn-light w-100"
                              for="btn-check-loanconti2"
                              >ผู้กู้รายใหม่ ไม่เคยกู้มาก่อน</label
                            >
                          </div>
                          <div
                            class="col-md-12 col-12 mt-3 text-center"
                            v-if="getDataFrom3.student_loan_continus != ''"
                          >
                            <label class="text-danger fw-bolder w-100"
                              >วิทยาลัยจะเปิดให้ลงทะเบียนกู้ กยศ. ในเดือนเมษายน
                              ปี
                              {{ getDataFrom3.select_year }}
                              โดยในตอนแรกผู้กู้จะต้องชำระเงินเองก่อน
                              <br />
                              เมื่อผ่านขั้นตอน กยศ.จะโอนเงินกลับคืนมาให้</label
                            >
                          </div>
                        </fieldset>
                      </div>
                      <!-- {{ this.getDataFrom3 }} -->
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div
                class="col"
                v-if="getqrcodeChkStatusPay.status != 'Paysuccess'"
              >
                <div class="d-inline-flex p-2" style="float: left">
                  <button
                    type="button"
                    class="btn btn-primary"
                    v-on:click="SetStepStatus(2)"
                  >
                    <font-awesome-icon :icon="['fas', 'backward']" /> ย้อนกลับ
                  </button>
                </div>
                <div class="d-inline-flex p-2" style="float: right">
                  <button type="submit" class="btn btn-primary">
                    ถัดไป <font-awesome-icon :icon="['fas', 'forward']" />
                  </button>
                </div>
              </div>
              <!-- {{ selectedDate }} -->
              <!-- <v-date-picker v-model="selectedDate" /> -->
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import $ from "jquery";
export default {
  data() {
    return {
      // selectedDate: window.moment().format("YYYY/MM/DD"),
      // dateTest: moment().format("YYYY-MM-DD"),
      // selectedDate: new Date().toLocaleDateString("TH"),
      // buddhistYear: true,

      updatedDate: "",
      date: "",
      numbers: [],
      stu_birthData: "",
      stu_fat_birthData: "",
      stu_mom_birthData: "",

      stu_fat_mon: "",
      stu_mom_mon1: "",

      stu_receipt_news_otherData: [],

      status_lone: false,

      emailError: false,
      yearError: false,
      yearErrorDad: false,
      yearErrorMom: false,
      statusEmail: 0,
    };
  },
  async mounted() {
    if (this.tes_id != "" && this.DateStep.Step1 != "") {
      // get Data Step2
    } else {
      await this.$swal({
        icon: "error",
        title: "Oops...",
        text: "กรุณาดำเนินการขั้นตอน Login ก่อน...",
      });
      this.$store.dispatch("Main/SetStepStatus", 1);
      return;
    }

    await this.$store.dispatch("Step1/SetStepStatus");
    if (this.DateStep.Step2 == "") {
      await this.$swal({
        icon: "error",
        title: "Oops...",
        text: "กรุณาบันทึกข้อมูลในขั้นตอนที่ 1 ก่อน...",
      });
      await this.$store.dispatch("Main/SET_Onload", true);
      this.$store.dispatch("Main/SetStepStatus", 2);
      return;
    }
    this.$store.dispatch("Main/SET_Onload", false);
    await this.$store.dispatch("Step3/SetStep3");
    this.$store.dispatch("Step3/GET_DataNation");
    this.$store.dispatch("Step3/GET_DataLineage");
    this.$store.dispatch("Step3/GET_DataReligion");
    this.$store.dispatch("Step3/GET_DataBlood");
    this.$store.dispatch("Step3/GET_DataParentStatus");
    this.$store.dispatch("Step2/GET_DataPrename");
    this.$store.dispatch("Step3/GET_DataOccupationNew");
    this.$store.dispatch("Step3/GET_DataDefective");
    this.$store.dispatch("Step3/GET_DataLivingstate");
    this.$store.dispatch("Step3/GET_Signup_date");

    if (this.getDataFrom3.student_loan_stat == 0) {
      this.status_lone = false;
    } else {
      this.status_lone = true;
    }

    this.getMaxDate();
    this.getMinDate();

    this.generateNumber_Sis_Bro();
    if (this.getDataFrom3.stu_fat_mon != null) {
      this.stu_fat_mon = this.getDataFrom3.stu_fat_mon;
      // this.formatCurrencyF();
    }
    if (this.getDataFrom3.stu_mom_mon1 != null) {
      this.stu_mom_mon1 = this.getDataFrom3.stu_mom_mon1;
      // this.formatCurrencyM();
    }
    this.scrollToTop();

    $(document).ready(function () {
      $(".IsNumber").keydown(function (e) {
        // Allow: backspace, delete, tab, escape, enter and .
        if (
          $.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
          // Allow: Ctrl+A
          (e.keyCode == 65 && e.ctrlKey === true) ||
          // Allow: home, end, left, right
          (e.keyCode >= 35 && e.keyCode <= 39)
        ) {
          // let it happen, don't do anything
          return;
        }
        // Ensure that it is a number and stop the keypress
        if (
          (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
          (e.keyCode < 96 || e.keyCode > 105)
        ) {
          e.preventDefault();
        }
      });
    });

    this.getDataFrom3.stu_receipt_news_other
      ? (this.stu_receipt_news_otherData =
          this.getDataFrom3.stu_receipt_news_other.split(", "))
      : "";

    if (
      this.getDataFrom3.stu_birth != null &&
      this.getDataFrom3.stu_birth != ""
    ) {
      const dateString = this.getDataFrom3.stu_birth;
      const day = dateString.substring(0, 2);
      const month = dateString.substring(2, 4);
      const year = dateString.substring(4, 8);
      const formattedDate = `${year - 543}-${month}-${day}`;

      this.stu_birthData = formattedDate;
    }

    if (
      this.getDataFrom3.stu_father_birth != null &&
      this.getDataFrom3.stu_father_birth != ""
    ) {
      const dateStringF = this.getDataFrom3.stu_father_birth;
      const dayF = dateStringF.substring(6, 8);
      const monthF = dateStringF.substring(4, 6);
      const yearF = dateStringF.substring(0, 4);
      const formattedDateF = `${yearF}-${monthF}-${dayF}`;

      this.stu_fat_birthData = formattedDateF;
    }

    if (
      this.getDataFrom3.stu_mother_birth != null &&
      this.getDataFrom3.stu_mother_birth != ""
    ) {
      const dateStringM = this.getDataFrom3.stu_mother_birth;
      const dayM = dateStringM.substring(6, 8);
      const monthM = dateStringM.substring(4, 6);
      const yearM = dateStringM.substring(0, 4);
      const formattedDateM = `${yearM}-${monthM}-${dayM}`;

      // console.log(formattedDateM);

      this.stu_mom_birthData = formattedDateM;
    }

    // console.log(this.stu_birthData);
    // console.log(this.stu_fat_birthData);
    // console.log(this.stu_mom_birthData);
  },
  watch: {
    stu_receipt_news_otherData: {
      handler() {
        this.text = this.stu_receipt_news_otherData.join(", ");
        this.getDataFrom3.stu_receipt_news_other = this.text;
        // console.log(this.stu_receipt_news_otherData);
      },
    },
  },
  methods: {
    maxSalaryFat(event) {
      const value = event.target.value;
      if (value.length > 6) {
        this.getDataFrom3.stu_fat_mon = value.slice(0, 6); // ตัดตัวเลขส่วนเกินออก
      }
    },
    maxSalaryMom(event) {
      const value = event.target.value;
      if (value.length > 6) {
        this.getDataFrom3.stu_mom_mon1 = value.slice(0, 6); // ตัดตัวเลขส่วนเกินออก
      }
    },
    maxAge(event) {
      const value = event.target.value;
      if (value.length > 3) {
        this.getDataFrom3.stu_age = value.slice(0, 3); // ตัดตัวเลขส่วนเกินออก
      }
    },
    getMaxDate() {
      const currentDate = new Date();
      currentDate.setFullYear(currentDate.getFullYear() - 4);
      const dateTest = currentDate.toISOString().split("T")[0];
      const Year = parseInt(dateTest.split("-")[0]) + 4;
      const month = dateTest.split("-")[1];
      const day = dateTest.split("-")[2];
      const thaiDate = `${Year}-${month}-${day}`;
      return thaiDate;
    },
    getMinDate() {
      return "1963-01-01";
    },
    getMinDateDadMom() {
      return "1823-01-01";
    },
    validateEmail() {
      const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;
      if (!emailPattern.test(this.getDataFrom3.stu_email)) {
        if (this.getDataFrom3.stu_email != "") {
          this.emailError = true;
          // console.log("รูปแบบอีเมลไม่ถูกต้อง");
        } else {
          this.emailError = false;
        }
      } else {
        this.emailError = false;
      }
    },
    formatDate() {
      const date = new Date(this.stu_birthData);
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      const currentYear = new Date().getFullYear();
      const age = currentYear - year;
      this.getDataFrom3.stu_age = age;

      // console.log(currentYear);

      // const dateTest = new Date(2567, 1, 29);

      // const result = dateTest.toLocaleDateString("th-TH", {
      //   year: "numeric",
      //   month: "numeric",
      //   day: "numeric",
      // });

      // console.log(result);

      const formattedDate = `${day}${month}${parseInt(year) + 543}`;

      if (formattedDate == "NaNNaNNaN") {
        this.getDataFrom3.stu_birth = "";
      } else {
        this.getDataFrom3.stu_birth = formattedDate;
      }

      if (year < 1963 || year >= currentYear) {
        this.yearError = true;
      } else {
        this.yearError = false;
      }
    },
    formatDatefat() {
      const date = new Date(this.stu_fat_birthData);
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      const currentYear = new Date().getFullYear();

      // console.log(year);

      const formattedDate = `${year}${month}${day}`;
      // this.updatedDate = formattedDate;

      if (formattedDate == "NaNNaNNaN") {
        this.getDataFrom3.stu_father_birth = "";
      } else {
        this.getDataFrom3.stu_father_birth = formattedDate;
      }

      if (year < 1823 || year >= currentYear) {
        this.yearErrorDad = true;
      } else {
        this.yearErrorDad = false;
      }
    },
    formatDatemom() {
      const date = new Date(this.stu_mom_birthData);
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      const currentYear = new Date().getFullYear();

      const formattedDate = `${year}${month}${day}`;
      // this.updatedDate = formattedDate;
      this.getDataFrom3.stu_mother_birth = formattedDate;
      // console.log(formattedDate);

      if (formattedDate == "NaNNaNNaN") {
        this.getDataFrom3.stu_mother_birth = "";
      } else {
        this.getDataFrom3.stu_mother_birth = formattedDate;
      }

      if (year < 1823 || year >= currentYear) {
        this.yearErrorMom = true;
      } else {
        this.yearErrorMom = false;
      }
    },
    generateNumber_Sis_Bro() {
      for (let i = 0; i <= 30; i++) {
        this.numbers.push(i);
      }
    },
    async student_loanstat1() {
      this.getDataFrom3.student_loan_continus = "";
      this.status_lone = false;
    },
    async student_loanstat2() {
      this.status_lone = true;
    },
    // formatCurrencyF() {
    //   const From3 = this.getDataFrom3;
    //   console.log(this.stu_fat_mon);

    //   // if (this.stu_fat_mon.includes(",")) {
    //   //   const F_mon_array = this.stu_fat_mon.split(",");
    //   //   this.stu_fat_mon = F_mon_array[0] + F_mon_array[1];
    //   //   console.log("Test ,");
    //   // }

    //   if (From3.stu_fat_mon == ".00" || From3.stu_fat_mon == "00") {
    //     if (this.stu_fat_mon != "") {
    //       From3.stu_fat_mon = this.stu_fat_mon;
    //       const value = From3.stu_fat_mon.replace(/,/g, "");
    //       const modifiedValue = value;
    //       const formattedValue = parseFloat(modifiedValue)
    //         .toFixed(2)
    //         .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    //       this.stu_fat_mon = formattedValue;
    //     } else {
    //       From3.stu_fat_mon = "";
    //       this.stu_fat_mon = "";
    //     }
    //     // console.log(this.stu_fat_mon);
    //     // console.log(From3.stu_fat_mon);
    //     return;
    //   } else if (this.stu_fat_mon != "" && this.stu_fat_mon != null) {
    //     From3.stu_fat_mon = this.stu_fat_mon;
    //     const value = From3.stu_fat_mon.replace(/,/g, "");
    //     // console.log(From3.stu_fat_mon);
    //     const modifiedValue = value;
    //     const formattedValue = parseFloat(modifiedValue)
    //       .toFixed(2)
    //       .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    //     this.stu_fat_mon = formattedValue;
    //   } else {
    //     this.stu_fat_mon = "";
    //     From3.stu_fat_mon = "00";
    //   }
    //   console.log(this.stu_fat_mon);
    //   console.log(From3.stu_fat_mon);
    // },
    // formatCurrencyM() {
    //   const From3 = this.getDataFrom3;

    //   if (this.stu_mom_mon1.includes(",")) {
    //     const M_mon_array = this.stu_mom_mon1.split(",");
    //     this.stu_mom_mon1 = M_mon_array[0] + M_mon_array[1];
    //     // console.log(this.stu_fat_mon);
    //     // console.log("Test ,");
    //   }

    //   if (From3.stu_mom_mon1 == ".00" || From3.stu_mom_mon1 == "00") {
    //     if (this.stu_mom_mon1 != "") {
    //       From3.stu_mom_mon1 = this.stu_mom_mon1;
    //       const value = From3.stu_mom_mon1.replace(/,/g, "");
    //       const modifiedValue = value;
    //       const formattedValue = parseFloat(modifiedValue)
    //         .toFixed(2)
    //         .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    //       this.stu_mom_mon1 = formattedValue;
    //     } else {
    //       From3.stu_mom_mon1 = "";
    //       this.stu_mom_mon1 = "";
    //       return;
    //     }
    //   } else if (this.stu_mom_mon1 != "" && this.stu_mom_mon1 != null) {
    //     From3.stu_mom_mon1 = this.stu_mom_mon1;
    //     const value = From3.stu_mom_mon1.replace(/,/g, "");
    //     const modifiedValue = value;
    //     const formattedValue = parseFloat(modifiedValue)
    //       .toFixed(2)
    //       .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    //     this.stu_mom_mon1 = formattedValue;
    //   } else {
    //     this.stu_mom_mon1 = "";
    //     From3.stu_mom_mon1 = ".00";
    //   }
    // },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // เพื่อให้การเลื่อนเป็นแบบนุ่มนวล
      });
    },
    async SetStepStatus(payload) {
      if (this.getDataFrom3.stu_fat_mon == null) {
        this.getDataFrom3.stu_fat_mon = 0;
      }
      if (this.getDataFrom3.stu_mom_mon1 == null) {
        this.getDataFrom3.stu_mom_mon1 = 0;
      }
      const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;
      if (!emailPattern.test(this.getDataFrom3.stu_email)) {
        if (this.getDataFrom3.stu_email != "") {
          this.statusEmail = 1;
          await this.$swal({
            icon: "error",
            title: "ผิดพลาด",
            text: "กรุณากรอก Email ให้ถูกต้อง",
          });
        }
      } else if (this.getDataFrom3.stu_receipt_news_other == "") {
        await this.$swal({
          icon: "error",
          title: "ผิดพลาด",
          text: "กรุณาเลือก ได้รับข่าวสารจาก ด้วย",
        });
        return;
      }
      if (this.statusEmail == 0) {
        if (this.getDataFrom3.stu_email == "") {
          this.getDataFrom3.tes_id = this.tes_id;
          await this.$store.dispatch("Step3/SetStepStatus");
          if (this.DateStep3.status == true) {
            await this.$swal({
              icon: this.DateStep3.type,
              title: this.DateStep3.alert,
              text: this.DateStep3.text,
            });

            await this.$store.dispatch("Main/SET_Onload", true);
            this.$store.dispatch("Main/SetStepStatus", payload);
          } else if (this.DateStep3.status == false) {
            await this.$swal({
              icon: this.DateStep3.type,
              title: this.DateStep3.alert,
              html: `${this.DateStep3.text}<br><a href="https://m.me/lannapolyCNX" target="_blank" style="color: blue; text-decoration: none;">Facebook Messenger</a>/<a href="https://line.me/ti/p/~@lannapoly" target="_blank" style="color: blue; text-decoration: none;">Line</a>`,
            });
          }
        } else {
          this.getDataFrom3.tes_id = this.tes_id;
          await this.$store.dispatch("Step3/SetStepStatus");
          if (this.DateStep3.status == true) {
            await this.$swal({
              icon: this.DateStep3.type,
              title: this.DateStep3.alert,
              text: this.DateStep3.text,
            });
            await this.$store.dispatch("Main/SET_Onload", true);
            this.$store.dispatch("Main/SetStepStatus", payload);
          } else if (this.DateStep3.status == false) {
            await this.$swal({
              icon: this.DateStep3.type,
              title: this.DateStep3.alert,
              html: `${this.DateStep3.text}<br><a href="https://m.me/lannapolyCNX" target="_blank" style="color: blue; text-decoration: none;">Facebook Messenger</a>/<a href="https://line.me/ti/p/~@lannapoly" target="_blank" style="color: blue; text-decoration: none;">Line</a>`,
            });
          }
        }
      }
      this.statusEmail = 0;
    },
  },

  computed: {
    ...mapGetters({
      AdmissionYear: "Main/_getAdmissionYear",
      tes_id: "Main/_getTesID",
      DateStep: "Main/_getDateStep",
      DateStep3: "Main/_getDateStep3",
      getDataFrom3: "Step3/_getDataFrom3",
      getDataNation: "Step3/_getDataNation",
      getDataLineage: "Step3/_getDataLineage",
      getDataReligion: "Step3/_getDataReligion",
      getDataBlood: "Step3/_getDataBlood",
      getDataParentStatus: "Step3/_getDataParentStatus",
      getDataPrename: "Step2/_getDataprename",
      getDataOccupationNew: "Step3/_getDataOccupationNew",
      getDataDefective: "Step3/_getDataDefective",
      getDataLivingstate: "Step3/_getDataLivingstate",
      getSetStep3: "Step3/_SetStep3",
      getSignup_date: "Step3/_GetSignup_date",
      DataStep3: "Step3/_GetDataStep3",
      getqrcodeChkStatusPay: "Step6/_getqrcodeChkStatusPay",
    }),
  },
};
</script>

<style scoped>
.error-border {
  border: 2px solid red;
}
</style>
